import { KilometerMilesCalculate } from '../utils';

export const SEARCH_RADIUS_IN_KILOMETER = 25000;
export const SEARCH_RADIUS_IN_MILES = KilometerMilesCalculate.calculateToMiles(SEARCH_RADIUS_IN_KILOMETER);
